export default [
  {
    path: "/",
    component: () => import("../views/dashboard/Index.vue"),
    children: [
      {
        path: "",
        name: "AdminDashboard",
        redirect: () => {
          return "farmList";
        },
        // component: () => import("../views/dashboard/Dashboard.vue"),
        // meta: { requiresAuth: false },
      },
      {
        path: "profile",
        name: "profile",
        component: () => import("../views/user/Profile.vue"),
      },
      {
        path: "coming-soon",
        name: "ComingSoon",
        component: () => import("../views/ComingSoon.vue"),
      },
      {
        path: "/geofence",
        name: "Geofence",
        component: () => import("../views/geofence/FarmGeofence.vue"),
      },
      {
        path: "/geofence/sub",
        name: "GeofenceSub",
        component: () => import("../views/geofence/GeofenceSub.vue"),
      },
      {
        path: "/geofence/:farmid",
        name: "GeofenceFarm",
        component: () => import("../views/geofence/FarmGeofence.vue"),
      },
      {
        path: "/geofence/walkmeasure",
        name: "GeofenceWalk",
        component: () => import("../views/geofence/Walk.vue"),
      },
      {
        path: "/geofence/saved",
        name: "GeofenceSaved",
        component: () => import("../views/geofence/SavedGeoFence.vue"),
      },
      {
        path: "/farmList",
        component: () => import("../views/my_farm/Index.vue"),
        children: [
          {
            path: "",
            name: "My farm",
            component: () => import("../views/my_farm/MyFarm.vue"),
          },
          {
            path: "register",
            name: "FarmRegistartion",
            component: () => import("../views/my_farm/FarmRegistration.vue"),
          },
          {
            path: "editfarm/:id",
            name: "EditPrimaryFarm",
            component: () => import("../views/my_farm/EditPrimaryFarm.vue"),
          },
          {
            path: "zones/:id",
            name: "ZonesList",
            component: () => import("../views/my_farm/FarmZoneList.vue"),
          },
          {
            path: "add-zone",
            name: "FarmZones",
            component: () => import("../views/my_farm/FarmGeofenceZone.vue"),
          },
          {
            path: "edit-zone/:id",
            name: "FarmEditZone",
            component: () =>
              import("../views/my_farm/FarmGeofenceZoneEdit.vue"),
          },
          {
            path: "zone-details/:id",
            name: "ZoneDetails",
            component: () => import("../views/my_farm/ZoneDetails.vue"),
          },
          {
            path: ":id",
            name: "SingleFarm",
            component: () => import("../views/my_farm/Singlefarm.vue"),
          },
          // {
          //   path: 'editfarm/:id',
          //   name: 'EditFarm',
          //   component: () => import("../views/my_farm/EditFarm.vue")
          // },
          {
            path: "/googlemap",
            name: "GoogleMap",
            component: () => import("../views/my_farm/GoogleMap.vue"),
          },
        ],
      },
      {
        path: "/forest-assessments",
        component: () => import("../views/forest_assessments/Index.vue"),
        children: [
          {
            path: "",
            name: "EUDRForestAssessments",
            component: () =>
              import("../views/forest_assessments/ForestAssessmentsList.vue"),
          },
        ],
      },
      {
        path: "/deforestation",
        component: () => import("../views/deforestation/Index.vue"),
        children: [
          {
            path: "",
            name: "DeforestationList",
            component: () => import("../views/deforestation/ListPage.vue"),
          },
          {
            path: ":id",
            name: "DeforestationDetails",
            component: () => import("../views/deforestation/Details.vue"),
          },
        ],
      },
      {
        path: "/certificate",
        component: () =>
          import("../views/deforestation/ComplianceCertification.vue"),
        name: "Certificate",
        children: [],
      },
      {
        path: "certification-eudr-assement/:id",
        name: "ComplianceCertificationEudrAssessment",
        component: () => import("../views/deforestation/ComplainceAssessmentReport.vue"),
      },
      {
        path: "/Payment",
        component: () => import("../views/deforestation/Payment.vue"),
        name: "Payment",
        children: [],
      },
    ],
  },
];
